import classes from "./Layout.module.scss";
import MainNavigationTop from "./MainNavigationTop";
import {useContext, useRef, useState} from "react";
import Footer from "./Footer";
import useFileDrop from "../../hooks/useFileDrop";
import UserFinishSignupForm from "../other/userFinishSignupForm/UserFinishSignupForm";
import UserContext from "../../store/userContext";
import PopupCustom from "../ui/PopupCustom";

import magazineImg from "../../batens_verden/magasin.webp";
import AdvertPopupGeo from "../advert/AdvertPopupGeo";

function Layout(props){
	const [isBannerVisible, setIsBannerVisible] = useState(false);
	const mainRef = useRef();
	const {isProfileCompleted} = useContext(UserContext);

	useFileDrop(mainRef);

	return (<>
		<div lang={"no"} className={classes.grid_container}>
			<MainNavigationTop isBannerVisible={isBannerVisible} setIsBannerVisible={setIsBannerVisible}/>
			<main ref={mainRef} className={classes.grid_main} style={isBannerVisible?{paddingTop:"0"}:null}>
				{props.children}
			</main>
			{/*<PopupCustom popupKey={'bv-kampanje-mai-2025'} delay={3000}>
				<div style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: '1em'
				}}>
					<h3 style={{
						margin: '0 auto',
						textAlign: 'center',
						marginBottom: '1em',
						fontWeight: '600',
						borderBottom: '1px solid #e6e6e6',
						width: '100%'
					}}>Tidsbegrenset tilbud</h3>
					<div style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "center",
						gap: '1em'
					}}>
						<img src={magazineImg} alt={"magasin"} style={{maxWidth: '45%', maxHeight: '270px'}}/>
						<div style={{color: '#575757'}}>
							<h4>Båtens Verden 1 år</h4>

							<p>+ Få med Havneguiden gratis i 1 år (verdi 598,-)*</p>

							<p>+ 1 gratis utgave</p>

							<p>Totalverdi <s>1403 kr</s>
								<br/>
								<span style={{fontSize: '2em', fontWeight: '500'}}>399 kr</span>
							</p>

							<p>57 kr per blad – totalt 7 utgaver</p>
						</div>
					</div>
					<a href={'https://abo.b-v.no/25_04/?kilde=bv%20nett'} target={'_blank'} style={{
						background: '#81d052',
						padding: '1em',
						marginTop: '2em',
						width: '80%',
						textAlign: 'center',
						fontWeight: "bold",
						color: 'white',
						borderRadius: '14px',
						cursor: 'pointer'
					}}>Kjøp</a>
				</div>
			</PopupCustom>*/}
			{<AdvertPopupGeo adPlacementId={'6718eaaf3475a38100e966bd'} name={'nordav-mai2025'}
							 delayUntilShow={5}
							 hideFromPathnames={['/bv1', '/bv1/', '/artikkel/ny-prisvinnende-daycruiser-cormate-utility-27-er-designet-for-batglede',
							 '/sjoen-for-alle-utstillere', '/sjoen-for-alle']}
							 title={'NorDav kampanje resten av Mai!'}
							 body={<>Tilbud på eksklusive davit-systemer for enkel
								 <br/> transport av joller og vannscootere på dekk.
							 </>}
							 buttonText={'Se tilbud'}
			/>}
			{/*<AdvertPopupGeo adPlacementId={'679a52c64d57f69498f1f30d'} name={'båtbilcaravan-mars'}
							 delayUntilShow={5}
							 hideFromPathnames={['/bv1', '/bv1/', '/artikkel/denne-legenden-har-na-blitt-en-enda-bedre-bat', '/artikkel/na-opplever-megleren-okt-interesse-for-brukte-bater-over-40-fot']}
							 title={'Båt og Caravan 7.-9. mars i Ålesund'}
							 body={<>Båt og Caravan 7. – 9. mars i Ålesund
								 <br/>Besøk Nordvestlandets største messe med innendørs og flytende utstilling</>}
							 buttonText={'Les mer'}
							 background={'rgba(0, 70, 50, 0.94)'}
			/>*/}
			<Footer leftChildren={<>
				<p>Båtens Verden er hele Norges båtblad, utgis syv ganger årlig, i 19. årgang.
					<br/>
					Tips oss: <b><a href="mailto:tips@b-v.no">tips@b-v.no</a></b></p>
				<p>Ansvarlig redaktør: Vetle Børresen
					<br/>Alt innhold er opphavsrettslig beskyttet © VB Media AS</p>
			</>} rightLinks={[
				{t: 'Magasin', l: 'https://abo.b-v.no'},
				{t: 'Annonsere', l: 'https://annonse.vbmedia.no'},
				{t: 'Om Båtens Verden', l: 'https://abo.b-v.no/om'},
				{t: 'Kontakt oss', l: 'https://abo.b-v.no/kontakt'},
				{t: 'Personværnerklæring', l: '/personvernerklaering'}
			]}/>
		</div>
		{isProfileCompleted === false&&<UserFinishSignupForm/>}
	</>)
}


export default Layout;